module.exports = __webpack_public_path__ + "img/we-help-welearn.4f66b481.png";